/**
 * Crafting System Configuration
 * Time-based crafting with queue support (similar to research)
 */

export const CRAFTING_CONFIG = {
  // Maximum items in queue (excluding current)
  maxQueueSize: 5,

  // Quality mapping by recipe tier (fixed, not random)
  tierQuality: {
    1: 0.70,   // Tier 1: 70% quality
    2: 0.80,   // Tier 2: 80% quality
    3: 0.90,   // Tier 3: 90% quality
    4: 1.00,   // Tier 4: 100% quality
    5: 1.10,   // Tier 5: 110% quality
    6: 1.15,   // Tier 6: 115% quality
    7: 1.20,   // Tier 7: 120% quality
    8: 1.25,   // Tier 8: 125% quality (max)
  },

  // Base crafting time in SECONDS by tier
  baseCraftTime: {
    1: 30,     // 30 seconds
    2: 60,     // 1 minute
    3: 120,    // 2 minutes
    4: 240,    // 4 minutes
    5: 480,    // 8 minutes
    6: 900,    // 15 minutes
    7: 1800,   // 30 minutes
    8: 3600,   // 1 hour
  },

  // Cancel refund percentage
  cancelRefundPercent: 0.50,  // 50% refund on cancel

  // Categories for UI tabs
  categories: {
    equipment: { id: 'equipment', name: 'Equipment', icon: '⚔️' },
    consumables: { id: 'consumables', name: 'Consumables', icon: '🧪' },
    materials: { id: 'materials', name: 'Materials', icon: '📦' },
  },
};

// Categories for UI display
export const CRAFTING_CATEGORIES = {
  equipment: { id: 'equipment', name: 'Equipment', icon: '⚔️' },
  consumables: { id: 'consumables', name: 'Consumables', icon: '🧪' },
  materials: { id: 'materials', name: 'Materials', icon: '📦' },
};

export default CRAFTING_CONFIG;
